// Gestão do Realizado. Espelha backend/config.py ROLES_GESTAO_REALIZADO — mantenha em sincronia.
export const ROLES_GESTAO_REALIZADO = ["admin", "financeiro", "ADMFIN"];
export const EMPRESAS_REALIZADO = ["CIGTA", "GT4W", "CRIA", "FLOW", "YOUX"];
